/* eslint-disable camelcase */
import axios from 'axios';
import { toast } from 'react-toastify';
import { showLoginModal } from 'controllers/login-modal-controller';

let isShowingToast = false;

const noop = () => null;

function createInstance(apiUrl) {
  return axios.create({
    baseURL: apiUrl,
    timeout: 30000,
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

function handleRequest(request) {
  const token = localStorage.getItem('userToken');
  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }
  return request;
}

function handleResponse(response) {
  if (response.config.responseType === 'blob') {
    return response;
  }
  return response.data;
}

function handleError(error) {
  if (error.response?.status === 401) {
    const requestUrl = error.response?.config?.url || '';

    if (!requestUrl.includes('/session') && !isShowingToast) {
      isShowingToast = true;
      toast.error('Sua sessão expirou. Por favor, faça login novamente.');
      showLoginModal();

      setTimeout(() => {
        isShowingToast = false;
      }, 3000);
    }
  }

  return Promise.reject(error);
}

export class Config {
  constructor({
    api_url = 'https://api.pro.agroger.com.br',
    has_user_header = false,
  }) {
    if (!api_url) throw new Error('Missing api_url');
    this.axios = createInstance(api_url, has_user_header);

    this.intercept('request', handleRequest);
    this.intercept('response', handleResponse, handleError);
  }

  intercept(hook, successFn = noop, errFn = () => {}) {
    const allowedHooks = new Set(['request', 'response']);
    if (!allowedHooks.has(hook)) {
      throw new Error(
        'Just request and response are allowed to be intercepted',
      );
    }

    this.axios.interceptors[hook].use(
      async (request) => {
        const data = successFn(request);
        if (hook === 'response' && !!data) {
          return successFn(request);
        }
        return request;
      },
      (error) => {
        errFn(error);
        return Promise.reject(error);
      },
    );
  }

  instance() {
    return this.axios;
  }
}

export default (config) => new Config(config);
